import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

const useTopics = params => {
  const [topics, setTopics] = useState();
  const [status, setStatus] = useState();
  //const { state: authState } = useAuth();

  useEffect(() => {
    try {
      (async () => {
        setStatus("LOADING");
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_OAUTH_URL}/lite/topics`,
          params
        });
        console.log(response.json);
        let data = response.data;
/*
        data.sort((a,b) => {
          var tA = a.topicname.match(/^\d+$/) ? 'number' : 'string';
          var tB = b.topicname.match(/^\d+$/) ? 'number' : 'string';
          if (tA === tB && tA === "string") {
            return a.Acr.localeCompare(b.Acr);
          } else if (tA === tB && tA === "number") {
            return +a.topicname - +b.topicname;
          } else {
            return tA === "string" ? -1 : 1;
          }
        });*/

        setTopics(data);
        setStatus("OK");
      })();
    } catch (e) {
      setStatus("ERROR");
    }
  }, []);

  console.log(topics);
  console.log(status);

  return {
    topics,
    status
  };
};

export default useTopics;
